const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: this.dataset.slides - 2.8,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: this.dataset.slides - 2,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: this.dataset.slides,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useA11y(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
